/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import { IApplicationState } from "../../models/store/storeTypes";
import { IUserInvitationPageDispatchProps, IUserInvitationPageOwnProps, IUserInvitationPageStateProps, UserInvitationPage } from "source/components/user/public/UserInvitationPage";

export function mapStateToProps(applicationState: IApplicationState, ownProps: IUserInvitationPageOwnProps): IUserInvitationPageStateProps {
    return {
    };
}

export function mapDispatchToProps(dispatch: any): IUserInvitationPageDispatchProps {
    return {
    };
}

export default connect<IUserInvitationPageStateProps, IUserInvitationPageDispatchProps, IUserInvitationPageOwnProps>(mapStateToProps, mapDispatchToProps)(UserInvitationPage);